<template>
  <div>
    <EditCostCenterDialog ref="editDialog" />

    <GenericReport
      ref="report"
      class="clean-list"
      hide-header
      orientation="horizontal"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="showRowDetails"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn color="primary" @click="newRow">
          Novo Centro de Custo...
        </v-btn>
      </template>
    </GenericReport>
  </div>
</template>

<script>
import { CostCenter } from '@/models'
import { brDateOnly, brYesNo } from 'oderon-commons/src/formatters'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import EditCostCenterDialog from '../../cost-centers/home/EditCostCenterDialog.vue'
import Store from './Store'

const two = (x) => {
  if (x == null) return '--'
  return x.toString().padStart(2, '0')
}

function plus(x) {
  if (x == null) return '---'
  if (x > 0) return `+${two(x)}`
  return `-${two(Math.abs(x))}`
}

export default {
  components: {
    GenericReport,
    EditCostCenterDialog
  },
  data() {
    return {
      adapterSpec: [
        { t: 'ID|', d: 'id', color: '#ccc' },
        { t: '|Nome', d: 'name' },
        {
          t: 'Dia Ref./Fat./Venc.|',
          d: (row) => {
            const r = two(row.referenceDay)
            const i = two(row.invoiceDay)
            const d = two(row.dueDay)
            const p = plus(row.monthDelta)
            return `${r} / ${i} / ${d} ${p}M`
          }
        },
        { t: 'Início Contrato|', d: 'contractStartDate', f: brDateOnly },
        { t: '1ª Medição|', d: 'measureStartDate', f: brDateOnly },
        { t: 'Meses|', d: 'contractLengthM' },
        { t: 'Forma Pagto|', d: 'paymentMethod' },
        { t: 'Nº Contrato|', d: 'contractCode' },
        {
          t: 'Aprov. Medição?',
          d: 'requiresMeasureApproval',
          f: brYesNo
        }
      ]
    }
  },
  computed: {
    customer() {
      return Store.row
    },

    // isto é computed por causa do nome do cliente no title
    reportSpec() {
      return {
        code: 'clientCCs',
        title: 'Centros de Custo: ' + this.customer.label,
        filters: [
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativos'
          }
        ]
      }
    }
  },

  methods: {
    reload() {
      this.$refs.report.reload()
    },

    async fetchData(ps) {
      let res = await CostCenter.findAll({
        customerIds: this.customer.id,
        ...ps
      })

      return res
    },

    showRowDetails({ row, isMiddle }) {
      if (isMiddle) {
        window.open(`/#/billing/cost-centers/${row.id}`, '_blank')
      } else {
        this.$router.push(`/billing/cost-centers/${row.id}`)
      }
    },

    async newRow() {
      let name = await this.$prompt('Digite o nome do novo centro de custo')
      if (name != null) {
        this.$loading(async () => {
          await CostCenter.save({
            customerId: this.customer.id,
            name: 'CC ' + name,
            dueDelta: 30
          })
          await Store.reload()
          this.$snack('Criado com sucesso')
        })
      }
    }
  }
}
</script>

<style></style>
